import heroBg from "../assets/fashion-hero.jpg";

export default function ComingSoon() {
  return (
    <main className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6 text-center">
      {/* Background */}
      <div aria-hidden className="absolute inset-0 bg-[#0c0c0c]">
        <img
          src={heroBg}
          alt=""
          className="size-full object-cover object-top"
          style={{ animation: "fadein 1.4s ease-out both" }}
        />
        {/* dark overlay */}
        <div className="absolute inset-0 bg-black/75" />
        {/* bottom vignette */}
        <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-black/80 to-transparent" />
        {/* top vignette */}
        <div className="absolute inset-x-0 top-0 h-1/4 bg-gradient-to-b from-black/60 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative flex flex-col items-center gap-5">
        {/* Brand wordmark */}
        <p
          className="brand-wordmark text-sm text-white/80"
          style={{ animation: "fadeSlideDown 0.9s cubic-bezier(0.22,1,0.36,1) 0.1s both" }}
        >
          Fashionere
        </p>

        {/* Coming Soon overline */}
        <p
          className="text-xl font-bold tracking-[0.35em] uppercase"
          style={{
            color: "var(--fashionere-salmon)",
            animation: "fadeSlideUp 0.8s cubic-bezier(0.22,1,0.36,1) 0.35s both",
          }}
        >
          Coming Soon
        </p>

        {/* Headline */}
        <h1
          className="text-5xl font-light text-white sm:text-6xl md:text-7xl"
          style={{ animation: "fadeSlideUp 0.9s cubic-bezier(0.22,1,0.36,1) 0.5s both" }}
        >
          The industry tool for<br />designers &amp; retail chains.
        </h1>

        {/* Tagline */}
        <p
          className="mt-1 max-w-lg text-base leading-relaxed text-white/55"
          style={{ animation: "fadeSlideUp 0.9s cubic-bezier(0.22,1,0.36,1) 0.7s both" }}
        >
          Design and launch next-gen product lines — built for the professionals who move fashion forward.
        </p>

        {/* Footer mark */}
        <div
          className="mt-4 flex flex-col items-center gap-3"
          style={{ animation: "fadein 1s ease-out 1s both" }}
        >
          <div className="h-px w-12 bg-white/20" />
          <span className="text-xs tracking-wide text-white/30">Fashionere · 2026</span>
        </div>
      </div>
    </main>
  );
}
